import React, { useState, useEffect } from 'react'
import { useIntl  } from 'react-intl';
import { notification } from 'antd';
import axios from 'axios';
import Cookies from 'universal-cookie';
import {calculateSHA256} from '../utils/utils'
import { API_TOKEN} from '../utils/constants';
import LoadingControl from '../controls/Loading';
import PasswordPage from '../controls/PasswordPage';

const PasswordPane = (props) => {  

  const [state, setState] = useState({
    error: null,
    isLoaded: false,
    settings: null
  });

  async function getData() {
    
      const res = await axios("/password");
      return res.data;
      }

  useEffect(() => {

      getData()
      .then(res => {
          setState({ error: null, isLoaded: true, credentials: res });
      })
      .catch(err => {
          setState( {error: err, isLoaded: false, credentials: null });
      });
  }, []);  

  const intl = useIntl();

  async function onSubmit(credentials) {
      credentials.password = await calculateSHA256(credentials.password);
      if (credentials.new_password)
      {
          credentials.new_password = await calculateSHA256(credentials.new_password);
      }

      axios.post("/password", credentials)
      .then(response => {
          const cookies = new Cookies();
          cookies.set(API_TOKEN, response.data, {maxAge: 60 * 60 * 24 * 30 * 2});

          window.location.href = "/";
      })
      .catch(err => {
        notification['error']({
          message: intl.formatMessage({id: 'Error'}),
          description: err.message + ". " + err.response.statusText,
          duration: 0
        });
      });        
    };
  
  if(state.error != null)
  {
      return (
          <div>
              <h3>{state.error.message}</h3>
          </div>
      );
  }
  else if (!state.isLoaded)
  {
      return (
          <div><LoadingControl/></div>
      );
  }
  else
  {
    return (
        <div>
            <PasswordPage credentials = {state.credentials} onSubmit = {(credentials) => onSubmit(credentials)}/>
        </div>
    );   
  }
}
  
export default PasswordPane;